import router from './index'
import store from '../store'
import Storage from '../utils/storage'
import NProgress from 'nprogress'
import {
  log
} from 'console'

const whiteList = ['/404', '/500']

router.beforeEach(async (to, from, next) => {
  console.log("路由守卫1",to);
  setTimeout(() => {
    console.log("路由守卫2",from);
  }, 2000);
  // console.log("路由守卫2",from);
  // localStorage.setItem("jrcToShopUrl",window.location.href)
  // 切换路由告诉金融村当前路由地址,从金融村直接登录进入该电商路径
  if (localStorage.getItem("from") && localStorage.getItem("from") == 'JRC' ) {
    console.log("商城记录当前路由信息==通用jrc",window.location);
    console.log("商城记录当前路由信息==通用jrc",to);
    console.log("商城记录当前路由信息==通用jrc",window.location.origin + to.fullPath);
    let data = {
      fromShop: true,
      formShopUrl: window.location.origin + to.fullPath,
      data: '子页面主动触发通讯切换路由',
      fromShopRoute:true
    };
    window.parent.postMessage(data, '*');
  }
  await store.dispatch('getCommonDataAction')
  // if (!store.state.app.site) {
  //   console.log(1);
  //   await store.dispatch('getCommonDataAction')
  // }
  if (!whiteList.includes(to.path)) {
    console.log(2);
    const {
      site
    } = store.state.app
    if (site && site.siteon === 0) {
      // 说明站点已经关闭了
      next('/500')
      return
    }
    if (Storage.getItem('refresh_token') && !store.state.user.user) {
      console.log(3);
      await store.dispatch('user/getUserDataAction')
    }
  }
  const routes = to.matched
  const matchedComponents = []
  if (routes.length !== 0) {
    console.log(4);
    for (let i = 0; i < routes.length; i++) {
      const route = routes[i]
      const comDefault = route.components.default
      let component
      if (typeof comDefault === 'object') {
        component = comDefault
      } else if (typeof comDefault === 'function') {
        component = await comDefault()
      }
      component = component.default || component
      if (typeof component.head === 'function') {
        component.metaInfo = component.head
      }
      matchedComponents.push(component)
    }

    let middleware
    for (let i = 0; i < matchedComponents.length; i++) {
      const com = matchedComponents[i]
      if (com.middleware) {
        middleware = com.middleware
        break
      }
    }

    if (middleware === 'auth-user') {
      console.log(5);
      const {
        user
      } = store.state.user
      if (!user) {
        console.log(6);
        if (Storage.getItem('isPublic')) {
          console.log(7);
          window.GSShop_awakeLogin();
        } else {
          console.log(8);
          // 路由拦截告诉金融村当前路由,此情况是商城里触发了金融村的登录窗口
          if (localStorage.getItem("from") && localStorage.getItem("from") == 'JRC' ) {
            console.log("商城路由拦截记录路由信息给金融村",window.location.href);
            let data = {
              fromShop: true,
              formShopUrl: window.location.href,
              data: '子页面主动触发通讯路由拦截'
            };
            window.parent.postMessage(data, '*');
          } else {
            next(`/login?forward=${encodeURIComponent(to.fullPath)}`)
          }
          
          // next()
          // next(`/login?forward=${encodeURIComponent(to.fullPath)}`)
        }
        return
      }
    }
  }
  NProgress.start()
  next()
})

router.afterEach((to,from) => {
  // console.log("路由守卫2",from);
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/router/router-hook.js